/**
 * Mirrors backend `InventoryReferenceType` enum (values must stay in sync).
 */
export const INVENTORY_REFERENCE_TYPE = {
  TRANSFER: 15,
  STOCK_ADJUSTMENT: 20,
  PURCHASE_ORDER: 25,
  CUSTOMER_RETURN: 30,
  SUPPLIER_RETURN: 35,
  SALE: 40,
  OPENING_BALANCE: 45,
  ITEM_MERGE: 55,
} as const

export type InventoryReferenceTypeValue = (typeof INVENTORY_REFERENCE_TYPE)[keyof typeof INVENTORY_REFERENCE_TYPE]

export type InventoryReferenceTypeSelectOption = {
  value: InventoryReferenceTypeValue
  label: string
}

/** Stock In page: allowed `reference_type` values (subset of inventory reference types). */
export const STOCK_IN_SOURCE_OPTIONS: InventoryReferenceTypeSelectOption[] = [
  { value: INVENTORY_REFERENCE_TYPE.PURCHASE_ORDER, label: 'Purchase' },
  { value: INVENTORY_REFERENCE_TYPE.OPENING_BALANCE, label: 'Opening Stock' },
  { value: INVENTORY_REFERENCE_TYPE.CUSTOMER_RETURN, label: 'Return' },
  { value: INVENTORY_REFERENCE_TYPE.STOCK_ADJUSTMENT, label: 'Adjustment In' },
]

/** Stock In History filter: create sources plus system-generated merge movements. */
export const STOCK_IN_HISTORY_REFERENCE_OPTIONS: InventoryReferenceTypeSelectOption[] = [
  ...STOCK_IN_SOURCE_OPTIONS,
  { value: INVENTORY_REFERENCE_TYPE.ITEM_MERGE, label: 'Item Merge' },
]
